<template>
  <div class="main-container subgroup-table-height">
    <transition :css="false">
    <el-dialog title="Edit Subgroup" :visible.sync="editModal" width="40%">
      <form>
       <arnergy-select
            v-model="form.groupID"
            label="Select Group"
            :items="groups"
          />
          <br />

  
 
        <div class="form-group">
          <label>Subgroup Name</label>
          <input
            type="text"
            v-model="form.subgroupname"
            style="height: 5rem;"
            class="form-control"
          />
        </div>
        <br />

        <div class="form-group">
          <label for="exampleFormControlTextarea1">Subgroup Description</label>
          <textarea
            v-model="form.subgroup_desc"
            class="form-control"
            id="exampleFormControlTextarea1"
            rows="3"
          ></textarea>
        </div>

        <div class="mt-5 form-check ml-3">
          <input
            class="form-check-input"
            v-model="form.status"
            type="checkbox"
            value=""
            id="defaultCheck1"
          />
          <label class="form-check-label" for="defaultCheck1">
            {{ form.status ? 'Disable Group' : 'Enable Group' }}
          </label>
        </div>
        <div class="pt-4 text-right">
          <div v-if="loader" className="text-center">
            <div class="submit-gif">
              <div
                class="spinner-border"
                style="width: 3rem; height: 3rem;"
                role="status"
              >
                <span class="sr-only">Loading...</span>
              </div>
            </div>
          </div>
          <div v-else>
            <button class="btn btn-primary" @click="updateGroup">
              Edit Subgroup
            </button>
          </div>
        </div>
      </form>
    </el-dialog>
    </transition>

    <div style="width: 100%;">
      <el-input
        style="max-width: 200px;"
        placeholder="Type something"
        prefix-icon="el-icon-search"
        a
        v-model="searchTerm"
      ></el-input>
      <vue-good-table
        :columns="fields"
        :rows="getSubgroups"
        :search-options="{ enabled: true, externalQuery: searchTerm }"
        :pagination-options="{ enabled: true }"
      >
        <template slot="table-row" slot-scope="props" style="background: red;">
          <!-- {{1}} -->
          <span v-if="props.column.field == 'actions'">
            <b-button
            :disabled="loading"
              size="md"
              variant="success"
              @click="editmodal(props.row)"
            >
              {{loading?"Loading...":"Edit Subgroup"}} &nbsp;
              <span class="fa fa-wrench"></span>
            </b-button>
          </span>
          <span v-else>{{ props.row[props.column.field] }}</span>
        </template>

        <template slot="pagination-bottom" slot-scope="props">
          <grey-pagination
            :total="props.total"
            :pageChanged="props.pageChanged"
            :perPageChanged="props.perPageChanged"
          ></grey-pagination>
        </template>
      </vue-good-table>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from 'vuex'
import ArnergySelect from "../kitchen/ArnergySelect.vue";
import {
  Select,
  Button,
  Autocomplete,
  Form,
  FormItem,
  Radio,
  Dialog,
  RadioGroup,
  RadioButton,
  // ...
} from 'element-ui'
import moment from 'moment'
moment.updateLocale('en', {
  monthsShort: 'jan_feb_mar_apr_may_june_july_aug_sept_oct_nov_dec'.split('_'),
})

const items = []
export default {
  components: {
        'el-dialog': Dialog,
        ArnergySelect

  },
  data() {
    return {
      searchTerm: '',
      value:"",
      selectOption: {
        enabled: true,
      },
      editModal: false,
      items: items,
      updateID: "",
      groups: [{ id: null, name: null }],
       loader: false,
      form: {
        groupID: null,
        subgroup_desc: null,
        subgroupname: null,
        status: false,
      },
      fields: [
        {
          field: 'groupname',
          label: 'Group Name',
          sortable: 'true',
        },
        {
          field: 'subgroupname',
          label: 'Subgroup Name',
          sortable: 'true',
        },
        {
          field: 'subgroupdesc',
          label: 'User Type',
          sortable: 'true',
        },
        {
          field: 'status',
          label: 'Status',
          sortable: 'true',
        },
        {
          field: 'actions',
          label: 'Actions',
        },
        // { key: 'dob', label: 'Date of birth', sortable: 'true'},
      ],
      cxTeamFields: [
        {
          field: 'groupname',
          label: 'Group Name',
          sortable: 'true',
        },
        {
          field: 'fu',
          label: 'Subgroup Name',
          sortable: 'true',
        },
        {
          field: 'Subgroup Description',
          label: 'User Type',
          sortable: 'true',
        },
        {
          field: 'Status',
          label: 'E-mail',
          sortable: 'true',
        },
        // { key: 'dob', label: 'Date of birth', sortable: 'true'},
        {
          field: 'gender',
          label: 'Gender',
          sortable: 'true',
        },
        // { key: 'wallet_balance', label: 'Wallet Balance', sortable: 'true'},
        // { key: 'is_active', label: 'Status', sortable: 'true'},
        // { key: 'last_login', label: 'Last Login', sortable: 'true'},
        {
          field: 'phoneNumber',
          label: 'Phone Number',
          sortable: 'true',
        },
        // { key: 'address', label: 'Address', sortable: 'true'},
        {
          field: 'updatedAt',
          label: 'Last Seen',
          sortable: 'true',
        },
        {
          field: 'actions',
          label: 'Actions',
        },
      ],
      currentPage: 1,
      details: ['UserDetails', 'allowUser'],
      perPage: 10,
      totalRows: items.length,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      filter: null,
      loading:false,
      modalInfo: {
        title: '',
        content: '',
      },
    }
  },
  computed: {
    ...mapGetters([
      'getUserById',
      'getDeviceById',
      'getUsers',
      'getGroups',
      'getSubgroups',
      'getDummy',
      'getDevices',
    ]),
    isACxTeam: {
      get() {
        if (this.$can('am', 'cxTeam') || this.$can('edit', 'user')) {
          return true
        } else {
          return true
        }
      },
    },
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return {
            text: f.label,
            value: f.key,
          }
        })
    },
  },
  methods: {
    formatDate(date) {
      return moment(date).format('Do MMM YYYY')
    },
    navTo(url, user) {
      this.$router.push({
        name: url,
        params: {
          userId: user,
        },
      })
    },
    info(item, index, button) {
      this.modalInfo.title = `Row index: ${index}`
      this.modalInfo.content = JSON.stringify(item, null, 2)
      this.$root.$emit('bv::show::modal', 'modalInfo', button)
    },
    resetModal() {
      this.modalInfo.title = ''
      this.modalInfo.content = ''
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    editmodal(row) {
      let {id}=row;
      this.loading=true
      console.log({row,g:this.getGroups});
      this.updateID = id
      const HTTP = this.$httpUtils.instance
      const url = `/customerSubGroups/${id}`
      HTTP.get(url)
        .then((res) => {
          try {
               this.editModal = true
          this.form.groupID = res.data.groupid;
          this.form.subgroup_desc = res.data.subgroupdesc;
          this.form.subgroupname = res.data.subgroupname
          this.form.status = res.data.status;
          let f= this.getGroups.find(v=>v.id==  this.form.groupID )
          this.value=f;
            this.loading=false

          } catch (error) {
            this.loading=false
          }
       
        })
        .catch((error) => {
          console.log('error', error)
        })
    },

    updateGroup(e) {
      e.preventDefault()
      const HTTP = this.$httpUtils.instance
      const data = {
        groupid: this.form.groupID,
        subgroupname: this.form.subgroupname,
        subgroupdesc: this.form.subgroup_desc,
        status: this.form.status ? 1 : 0,
        id: this.updateID,
      }
        this.loader = true
        console.log(data)
        HTTP.put(`/customerSubGroups/${this.updateID}`, data)
          .then((res) => {
            if (res.data) {
              this.editModal = false
              this.showAlert()
              this.loader = false
              this.fetchUsers()
              this.form.subgroup_desc = '';
              this.form.groupID ="";
              this.form.subgroupname= '';
              this.form.status = false;
            }
          })
          .catch((err) => {
            console.log(err)
          })
      
     
    },
    showAlert() {
      // Use sweetalert2
      this.$swal({
        title: 'Success',
        imageWidth: '40px',
        text: 'Subgroup Updated Successfully',
        icon: 'success',
        width: '550px',
      })
    },
    fetchUsers() {
      const HTTP = this.$httpUtils.instance
      //  filter={"include": ["installations"]}
      const url = `/customerSubGroups/getCustomerSubgroups
`
      HTTP.post(url)
        .then((response) => {
          const usersList = response.data
          this.$store.commit(
            'saveSubgroups',
            usersList.map((data) => ({
              groupname: data.groupname,
              subgroupname: data.subgroupname,
              subgroupdesc: data.subgroupdesc,
              status: data.status == 0 ? 'Disabled' : 'Enabled',
              id: data.id,
            })),
          )
          // console.log(this.getUserById(1))
        })
        .catch((error) => {
          console.log('error', error)
        })
    },
  },
  mounted() {
    this.fetchUsers()
     this.groups = this.getGroups
      .map((item) => {
        return {
          id: item.id,
          name: item.groupname,
        }
      })
      .sort((a, b) => {
        return a.name > b.name ? 1 : -1
      })
    // console.log(this.getDummy)
  },
}
</script>

<style scoped>
.card-title {
  font-size: 2.6rem;
}

table th,
table th span {
  font-size: 0.7em;
}
.subgroup-table-height {
  height: calc(100vh - 450px);
}
</style>



// WEBPACK FOOTER //
// src/components/pages/user-mgt/SubgroupInfo.vue